var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('hero'),_c('b-container',[_c('b-row',[_c('b-col',{attrs:{"md":"6"}},[_c('post-list')],1),_c('b-col',{attrs:{"md":"6"}},[_c('event-list')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }